import React, { useState, useRef, useEffect } from "react"
import OrderRequestorSelectComponent from "./orderRequestorSelect.component"
import { selectLoading } from "modules/notification"
import OrderRequestorSelectPanelComponent from "./orderRequestorSelectPanel.component"
import { getOrderRequestorDropdown } from "modules/stockflow/redux"
import { useSelector, useDispatch } from "react-redux"
import { cloneDeep } from "lodash"

function OrderRequestorSelectContainer({
  handleChange,
  disabled,
  value,
  styles, 
  textStyles,
  placeholder,
  type,
  dealerUuid
}) {
  const isFetching = useSelector(state => selectLoading(state, getOrderRequestorDropdown.typePrefix))
  const lang = useSelector((state) => state.constant.languages)
  const orderRequestorDropdown = useSelector((state) => state.stockflowOrder.orderRequestorDropdown)
  const [open, setOpen] = useState(false)
  const [isOpenList] = useState(false)
  const anchorRef = useRef(null)
  const prevOpen = useRef(open)
  const prevOpenList = useRef(isOpenList)
  const [selectAll, setSelectAll] = useState(false)
  const [search, setSearch] = useState("")
  const dispatch = useDispatch()

  useEffect(() => {
    let param = { search, type }
    if (dealerUuid) {
      param.request_to_dealer = dealerUuid
    }
    dispatch(getOrderRequestorDropdown(param))
  }, [search, type, dispatch, dealerUuid])

  useEffect(() => {
    if (prevOpen.current === true && open === false) {
      anchorRef.current.focus()
    }

    prevOpen.current = open
  }, [open])

  useEffect(() => {
    if (prevOpenList.current === true && isOpenList === false) {
      anchorRef.current.focus()
    }

    prevOpenList.current = isOpenList
  }, [isOpenList])

  useEffect(() => {
    setSelectAll(value.length === orderRequestorDropdown.length)
  }, [value, orderRequestorDropdown])

  const handleOpen = () => {
    setOpen(true)
  }
  const handleClose = () => {
    setOpen(false)
    setSearch("")
  }

  const handleSelectAll = async () => {
    if(!selectAll){
      let selectedProducts = orderRequestorDropdown.map(p => {
        return p.id
      })
      handleChange(selectedProducts)
    }else{
      handleChange([])
    }
  }

  const handleSelectRequestor = (requestor) => {
    let temp = cloneDeep(value)

    if(temp.findIndex(t => t === requestor.id) >= 0){
      temp = temp.filter( t => t !== requestor.id )
    }else{
      temp.push(requestor.id)
    }
    handleChange(temp)
  }

  const handleSearch = (value) => {
    setSearch(value)
  }

  return (
    <>
      <OrderRequestorSelectComponent
        anchorRef={anchorRef}
        disabled={disabled}
        value={value}
        handleClick={handleOpen}
        styles={styles}
        textStyles={textStyles}
        placeholder={placeholder}
        lang={lang}
      />
      <OrderRequestorSelectPanelComponent
        selectAll={selectAll}
        value={value}
        anchorRef={anchorRef}
        open={open}
        isOpenList={isOpenList}
        handleClose={handleClose}
        isFetching={isFetching}
        orderRequestorDropdown={orderRequestorDropdown}
        handleSelectAll={handleSelectAll}
        handleSelectRequestor={handleSelectRequestor}
        handleSearch={handleSearch}
        lang={lang}
      />
    </>
  )
}

export default OrderRequestorSelectContainer